<template>
    <div>
        <v-card class="default_card_wm elevation-0 px-4 py-3 mb-2">
            <v-row
                no-gutters
                class="d-flex justify-space-between align-center"
                v-if="!componentForAlreadyDeclaredItems"
            >
                <v-col cols="1">
                    <v-btn-icon
                        @click="showDataTable = !showDataTable"
                        :icon="showDataTable ? '$fa-chevron-up' : '$fa-chevron-down'"
                    />
                </v-col>
                <v-col cols="8">
                    <h4>
                        {{
                            fromAssistVATComponent
                                ? "Flux bancaires lettrés de la période déclarée"
                                : "Flux bancaires non lettrés"
                        }}
                    </h4>
                </v-col>
                <v-col cols="3" class="d-flex justify-end">
                    <v-btn
                        rounded
                        size="small"
                        @click="toggleNewManualRowDialog()"
                        v-if="fromAssistVATComponent"
                        class="mr-2"
                    >
                        Ajouter une ligne
                    </v-btn>
                    <v-btn
                        v-if="vatItems && vatItems.length"
                        rounded
                        @click="vatDeclarationAlreadyDone()"
                        :disabled="disabledVatDeclararionAlreadyDone"
                        size="small"
                    >
                        Déclaration de TVA déjà réalisée
                    </v-btn>
                </v-col>
            </v-row>
            <v-row no-gutters v-if="isGrossAmountExceeded" style="color: red"
                >La somme des montants TTC des sous-éléments d'un flux dépasse le montant TTC du
                flux initial.</v-row
            >
            <v-data-table
                class="table rounded-xl pa-2"
                :headers="headers"
                :items="sortedVatItems"
                :item-key="'key'"
                :striped="true"
                :dense="true"
                :fixedHeader="true"
                row-height="50px"
                :itemsPerPage="-1"
                :hide-default-footer="true"
                v-if="showDataTable"
            >
                <template
                    v-slot:header.checkbox
                    v-if="vatItems && vatItems.length && !componentForAlreadyDeclaredItems"
                >
                    <v-checkbox
                        :ripple="false"
                        hide-details
                        @click.stop="selectAllVatItems()"
                        color="primary"
                        :model-value="selectedVatItemIds.length === sourceItems.length"
                    />
                </template>
                <template v-slot:item="props">
                    <tr :key="props.item.bankTransactionId">
                        <td>
                            <v-checkbox
                                v-model="selectedVatItemIds"
                                @click.stop="emptyFunction()"
                                :value="props.item.bankTransactionId"
                                color="primary"
                                hide-details
                                v-if="!props.item.isSubItem && !componentForAlreadyDeclaredItems"
                                :disabled="!props.item.bankTransactionId"
                            />
                        </td>
                        <td>
                            <v-btn-icon
                                :icon="props.item.hasBeenSplitted ? '$add' : '$fa-cut'"
                                size="small"
                                @click="splitAssistItem(props.item)"
                                v-if="
                                    !props.item.isSubItem &&
                                    props.item.bankTransactionId &&
                                    !['Import', 'Intracom', 'Export', 'NoVat'].includes(
                                        props.item.type,
                                    ) &&
                                    !componentForAlreadyDeclaredItems
                                "
                            >
                            </v-btn-icon>
                            <v-btn-icon
                                icon="$oss-trash"
                                size="small"
                                v-if="
                                    (props.item.isSubItem || !props.item.bankTransactionId) &&
                                    !componentForAlreadyDeclaredItems
                                "
                                @click="deleteSubOrAddedItem(props.item)"
                            ></v-btn-icon>
                        </td>
                        <td class="text-left text-truncate" style="max-width: 100px">
                            <div v-if="!props.item.isSubItem">
                                {{ props.item.displayDate }}
                            </div>
                        </td>
                        <td class="text-left">
                            <div v-if="!props.item.isSubItem">
                                {{ props.item.wording }}
                                <v-chip
                                    v-for="(aaName, index) of props.item
                                        .toDisplayAccountableAccounts"
                                    :key="index"
                                    label
                                    variant="outlined"
                                    size="x-small"
                                    :color="props.item.getAccountableAccountColor(aaName)"
                                >
                                    {{ aaName }}
                                </v-chip>
                                {{ props.item.thirdParties }}
                            </div>
                        </td>
                        <td>
                            <v-select-filled
                                v-model="props.item.type"
                                :items="vatTypes"
                                item-title="name"
                                item-value="value"
                                hide-details
                                density="compact"
                                class="custom-field-input-vat"
                                v-if="!props.item.isSubItem"
                                @update:modelValue="applyType(props.item)"
                                :disabled="
                                    props.item.hasBeenSplitted || componentForAlreadyDeclaredItems
                                "
                            >
                            </v-select-filled>
                        </td>
                        <td class="text-center">
                            <v-select-filled
                                v-model="props.item.computedVatRate"
                                :items="availableVatRates(props.item.type)"
                                item-title="name"
                                item-value="value"
                                hide-details
                                :disabled="
                                    props.item.type === 'Import' ||
                                    props.item.type === 'Intracom' ||
                                    props.item.type === 'Export' ||
                                    props.item.type === 'NoVat' ||
                                    props.item.hasBeenSplitted ||
                                    componentForAlreadyDeclaredItems
                                "
                                density="compact"
                                class="custom-field-input-vat"
                                v-if="!props.item.hasBeenSplitted"
                            >
                            </v-select-filled>
                            <span v-else style="color: gray">
                                {{
                                    props.item.displayGrossAmount -
                                        getGrossAmountSum(props.item.bankTransactionId) >
                                    0
                                        ? "TTC initial : " +
                                          newCommonFormatCurrency(
                                              props.item.displayGrossAmount,
                                              undefined,
                                          )
                                        : ""
                                }}
                            </span>
                        </td>
                        <td class="text-center">
                            <template v-if="props.item.hasBeenSplitted">
                                {{
                                    props.item.displayGrossAmount -
                                        getGrossAmountSum(props.item.bankTransactionId) >
                                    0
                                        ? "A affecter : " +
                                          newCommonFormatCurrency(
                                              props.item.displayGrossAmount -
                                                  getGrossAmountSum(props.item.bankTransactionId),
                                              undefined,
                                          )
                                        : newCommonFormatCurrency(
                                              props.item.displayGrossAmount,
                                              undefined,
                                          )
                                }}
                            </template>
                            <v-text-field-filled
                                v-else
                                hide-details
                                v-model="props.item.grossAmount"
                                class="custom-field-input-vat"
                                :disabled="componentForAlreadyDeclaredItems"
                            >
                            </v-text-field-filled>
                        </td>
                        <td class="text-center">
                            <template v-if="props.item.hasBeenSplitted">
                                {{
                                    newCommonFormatCurrency(
                                        getNetAmountSum(props.item.bankTransactionId),
                                        undefined,
                                    )
                                }}
                            </template>
                            <template v-else>
                                {{
                                    newCommonFormatCurrency(props.item.displayNetAmount, undefined)
                                }}
                            </template>
                        </td>
                        <td>
                            <v-text-field-filled
                                v-model="props.item.vatAmount"
                                hide-details="auto"
                                dense
                                :minifyRules="true"
                                :max="props.item.grossAmount"
                                :xDense="true"
                                v-if="props.item.vatRate === null"
                                class="text-center"
                            >
                            </v-text-field-filled>
                            <template v-else-if="props.item.hasBeenSplitted">
                                {{
                                    newCommonFormatCurrency(
                                        getVatAmountSum(props.item.bankTransactionId),
                                        undefined,
                                    )
                                }}
                            </template>
                            <template v-else class="text-center">
                                {{
                                    newCommonFormatCurrency(props.item.displayVatAmount, undefined)
                                }}
                            </template>
                        </td>
                        <td>
                            <v-switch
                                class="mt-0"
                                v-model="props.item.toAdd"
                                hide-details
                                @update:modelValue="applyToAdd(props.item)"
                                v-if="!props.item.isSubItem && !componentForAlreadyDeclaredItems"
                            />
                            <v-btn-remove-icon
                                v-else
                                @click="removeAlreadyDeclaredItem(props.item)"
                                style="transform: scale(0.75)"
                            />
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <oss-dialog
            v-model="newManualRowDialog"
            title="Ajout d'une ligne manuelle"
            @valid="addManualRow()"
            @close="
                newManualRowDialog = false;
                resetNewManualRow();
            "
            :valid-disabled="
                !newManualRow.wording || !newManualRow.vatType || !newManualRow.grossAmount
            "
        >
            <div style="width: 750px">
                <v-row no-gutters class="my-1">
                    <v-col cols="1" />
                    <v-col cols="6" class="d-flex align-center">
                        <b>Indiquez le libellé à afficher :</b>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-center align-center">
                        <v-text-field-filled
                            hide-details
                            label="Libellé"
                            outlined
                            v-model="newManualRow.wording"
                            density="compact"
                        >
                        </v-text-field-filled>
                    </v-col>
                    <v-col cols="1" />
                </v-row>
                <v-row no-gutters class="my-1">
                    <v-col cols="1" />
                    <v-col cols="6" class="d-flex align-center">
                        <b>Indiquez le type de TVA :</b>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-center align-center">
                        <v-select-filled
                            hide-details
                            outlined
                            v-model="newManualRow.vatType"
                            :items="vatTypes"
                            item-title="name"
                            item-value="value"
                            density="compact"
                        >
                        </v-select-filled>
                    </v-col>
                    <v-col cols="1" />
                </v-row>
                <v-row no-gutters class="my-1">
                    <v-col cols="1" />
                    <v-col cols="6" class="d-flex align-center">
                        <b>Indiquez le montant TTC :</b>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-center align-center">
                        <v-text-field-filled hide-details v-model="newManualRow.grossAmount">
                        </v-text-field-filled>
                    </v-col>
                    <v-col cols="1" />
                </v-row>
                <v-row no-gutters class="mt-1 mb-3">
                    <v-col cols="1" />
                    <v-col cols="6" class="d-flex align-center">
                        <b>Indiquez le taux de TVA :</b>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-center align-center">
                        <v-select-filled
                            hide-details
                            outlined
                            v-model="newManualRow.vatRate"
                            :items="availableVatRates(newManualRow.vatType)"
                            item-title="name"
                            item-value="value"
                            :disabled="disableVatRate"
                            density="compact"
                        >
                        </v-select-filled>
                    </v-col>
                    <v-col cols="1" />
                </v-row>
            </div>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import {
    formatCurrencyWithoutDecimals,
    newCommonFormatCurrency,
} from "../../../../../backend/src/common/services/mathServices";
import { Component, Vue, toNative, Prop, Watch } from "vue-facing-decorator";
import { getSubItemsVatAssist } from "@/services/declaration/declarationServices";
import { VatItemAssist } from "../../../../../backend/src/common/declaration/declarationServices";

@Component({
    emits: ["delete-sub-or-added-item", "remove-already-declared-item", "add-item"],
})
export class VATDeclarationDetailCardAssist extends Vue {
    @Prop({ default: null }) vatItems: VatItemAssist[];
    @Prop({ default: null }) endDate: string;
    @Prop({ default: true }) fromAssistVATComponent: boolean;
    @Prop({ default: false }) isGrossAmountExceeded: boolean;
    @Prop({ default: false }) componentForAlreadyDeclaredItems: boolean;

    newManualRowDialog: boolean = false;

    newManualRow: {
        wording: string;
        grossAmount: number;
        vatAmount: number;
        vatRate: number;
        vatType: string;
    } = {
        wording: "",
        grossAmount: 0,
        vatAmount: 0,
        vatRate: 0,
        vatType: "",
    };

    vatTypes = [
        { name: "Collectée", value: "Collectée" },
        { name: "Déductible", value: "Déductible" },
        { name: "Import", value: "Import" },
        { name: "Intracom", value: "Intracom" },
        { name: "Export", value: "Export" },
        { name: "N/A", value: "NoVat" },
    ];

    showDataTable: boolean = true;

    selectedVatItemIds: string[] = [];

    get headers(): {
        title: string;
        value: string;
        width: string;
        align: "start" | "center" | "end";
    }[] {
        if (window.innerWidth >= 1600) {
            return [
                { title: "", value: "checkbox", width: "5%", align: "center" },
                { title: "", value: "", width: "5%", align: "center" },
                { title: "Date", value: "debitDate", width: "5%", align: "center" },
                { title: "Libellé", value: "wording", width: "25%", align: "start" },
                { title: "Type", value: "operationType", width: "15%", align: "center" },
                { title: "Taux", value: "vatRate", width: "10%", align: "center" },
                { title: "TTC", value: "grossAmount", width: "10%", align: "center" },
                { title: "HT", value: "netAmount", width: "10%", align: "center" },
                { title: "TVA", value: "vatAmount", width: "10%", align: "center" },
                {
                    title: this.componentForAlreadyDeclaredItems ? "" : "A déclarer",
                    value: "add",
                    width: "5%",
                    align: "center",
                },
            ];
        } else {
            return [
                { title: "", value: "checkbox", width: "5%", align: "center" },
                { title: "", value: "", width: "5%", align: "center" },
                { title: "Date", value: "debitDate", width: "5%", align: "center" },
                { title: "Libellé", value: "wording", width: "20%", align: "start" },
                { title: "Type", value: "operationType", width: "20%", align: "center" },
                { title: "Taux", value: "vatRate", width: "12%", align: "center" },
                { title: "TTC", value: "grossAmount", width: "10%", align: "center" },
                { title: "HT", value: "netAmount", width: "9%", align: "center" },
                { title: "TVA", value: "vatAmount", width: "9%", align: "center" },
                {
                    title: this.componentForAlreadyDeclaredItems ? "" : "A déclarer",
                    value: "add",
                    width: "5%",
                    align: "center",
                },
            ];
        }
    }

    get disableVatRate(): boolean {
        return ["Export", "Intracom", "Import"].includes(this.newManualRow.vatType);
    }

    get disabledVatDeclararionAlreadyDone(): boolean {
        return !this.selectedVatItemIds.length;
    }

    get company() {
        return this.$store.state.selected_company;
    }

    get sortedVatItems(): VatItemAssist[] {
        return this.vatItems.sort((a, b) => {
            // first sort: dateDebit
            const dateComparison =
                new Date(b.dateDebit).getTime() - new Date(a.dateDebit).getTime();
            if (dateComparison !== 0) {
                return dateComparison;
            }
            // second sort: wording
            const wordingComparison = a.wording.localeCompare(b.wording);
            if (wordingComparison !== 0) {
                return wordingComparison;
            }
            // third sort: bankTransactionId
            return a.bankTransactionId.localeCompare(b.bankTransactionId);
        });
    }

    get sourceItems(): VatItemAssist[] {
        return this.vatItems.filter((item) => item.bankTransactionId && !item.isSubItem) || [];
    }

    get selectedVatItems(): VatItemAssist[] {
        return this.vatItems?.filter((item) =>
            this.selectedVatItemIds.includes(item.bankTransactionId),
        );
    }

    @Watch("newManualRow.vatType")
    updateVatRate() {
        if (this.disableVatRate) {
            this.newManualRow.vatRate = 20;
        }
    }

    async vatDeclarationAlreadyDone() {
        this.selectedVatItems.forEach((item) => {
            item.isAlreadyDeclared = true;
        });
        this.selectedVatItemIds = [];
    }

    availableVatRates(vatType) {
        if (vatType === "Déductible") {
            return [
                { name: "Manuel", value: null },
                { name: "0%", value: 0 },
                { name: "2,1%", value: 2.1 },
                { name: "5,5%", value: 5.5 },
                { name: "8,5%", value: 8.5 },
                { name: "10%", value: 10 },
                { name: "20%", value: 20 },
            ];
        } else {
            return [
                { name: "0%", value: 0 },
                { name: "2,1%", value: 2.1 },
                { name: "5,5%", value: 5.5 },
                { name: "8,5%", value: 8.5 },
                { name: "10%", value: 10 },
                { name: "20%", value: 20 },
            ];
        }
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    formatCurrencyWithoutDecimals(value) {
        return formatCurrencyWithoutDecimals(value);
    }

    toggleNewManualRowDialog() {
        this.newManualRowDialog = !this.newManualRowDialog;
    }

    addManualRow() {
        const newItem = new VatItemAssist(
            null,
            this.endDate,
            this.newManualRow.wording,
            this.newManualRow.vatType,
            this.newManualRow.grossAmount,
            this.newManualRow.vatRate,
            undefined,
            this.newManualRow.vatAmount,
            true,
            [],
            false,
            false,
            null,
            this.getNewSubOrAddedItemId(),
            false,
        );
        this.$emit("add-item", newItem);
        this.toggleNewManualRowDialog();
        this.resetNewManualRow();
    }

    resetNewManualRow() {
        this.newManualRow = {
            wording: "",
            grossAmount: 0,
            vatAmount: 0,
            vatRate: 0,
            vatType: "",
        };
    }

    selectAllVatItems() {
        if (this.selectedVatItemIds.length === this.sourceItems?.length) {
            this.selectedVatItemIds = [];
        } else {
            this.selectedVatItemIds = this.sourceItems?.map((item) => item.bankTransactionId);
        }
    }

    emptyFunction() {}

    getSubItems(btId: string): VatItemAssist[] {
        return getSubItemsVatAssist(this.vatItems, btId);
    }

    getNewSubOrAddedItemId(): number {
        const maxSubItemId: number = this.vatItems?.length
            ? Math.max(...this.vatItems.map((item) => item.subOrAddedItemId))
            : 0;
        return maxSubItemId + 1;
    }

    createNewSubItem(sourceItem: VatItemAssist): VatItemAssist {
        const subItem = new VatItemAssist(
            sourceItem.bankTransactionId,
            sourceItem.dateDebit,
            sourceItem.wording,
            sourceItem.type,
            0,
            0,
            0,
            0,
            sourceItem.toAdd,
            sourceItem.accountingLines,
            true,
            false,
            null,
            this.getNewSubOrAddedItemId(),
            false,
        );
        return subItem;
    }

    splitAssistItem(sourceItem: VatItemAssist) {
        const subItems: VatItemAssist[] = this.getSubItems(sourceItem.bankTransactionId);
        const subItem = this.createNewSubItem(sourceItem);
        if (subItems?.length) {
            // add one sub-item to other sub-items
            // and pre-filling gross amount
            const difference: number =
                sourceItem.grossAmountBeforeSplit -
                this.getGrossAmountSum(subItem.bankTransactionId);
            subItem.grossAmount = difference > 0 ? difference : 0;
            this.$emit("add-item", subItem);
        } else {
            sourceItem.hasBeenSplitted = true;
            sourceItem.grossAmountBeforeSplit = sourceItem.grossAmount;
            sourceItem.grossAmount = 0;
            this.$emit("add-item", subItem);
            // add two sub-items because we want to keep the original in read-only mode
            const secondSubItem = this.createNewSubItem(sourceItem);
            this.$emit("add-item", secondSubItem);
        }
    }

    applyToAdd(sourceItem: VatItemAssist) {
        // sub-items work together
        const toAdd: boolean = sourceItem.toAdd;
        const subItems: VatItemAssist[] = this.getSubItems(sourceItem.bankTransactionId);
        for (const item of subItems) {
            item.toAdd = toAdd;
        }
    }

    applyType(sourceItem: VatItemAssist) {
        // sub-items work together
        const type: string = sourceItem.type;
        const subItems: VatItemAssist[] = this.getSubItems(sourceItem.bankTransactionId);
        for (const item of subItems) {
            item.type = type;
        }
    }

    deleteSubOrAddedItem(itemToDelete: VatItemAssist) {
        // emit an event to the parent due to a reactivity issue on vatItems prop, otherwise
        this.$emit("delete-sub-or-added-item", itemToDelete);
    }

    getGrossAmountSum(id: string): number {
        return this.vatItems
            .filter((item) => item.bankTransactionId === id)
            .reduce((acc, item) => acc + Number(item.grossAmount), 0);
    }

    getNetAmountSum(id: string): number {
        return this.vatItems
            .filter((item) => item.bankTransactionId === id)
            .reduce((acc, item) => acc + Number(item.netAmount), 0);
    }

    getVatAmountSum(id: string): number {
        return this.vatItems
            .filter((item) => item.bankTransactionId === id)
            .reduce((acc, item) => acc + Number(item.vatAmount), 0);
    }

    removeAlreadyDeclaredItem(assistItem: VatItemAssist) {
        assistItem.isAlreadyDeclared = false;
    }
}

export default toNative(VATDeclarationDetailCardAssist);
</script>
<style lang="scss">
tr {
    height: 38px !important;
}
.custom-field-input-vat .v-field__input {
    font-size: 0.8em !important;
    justify-content: center !important;
    text-align: center !important;
    padding-inline: 4px 2px !important;
}
</style>
